// React imports
import React from 'react';

// Third-party imports
import clsx from 'clsx';

// Styles
import styles from './CustomButton.module.scss';

interface CustomButtonProps {
    title: React.ReactNode;
    onAction?: (e?: React.MouseEvent) => void;
    isActive?: boolean;
}

const CustomButton = ({ title, onAction, isActive = true }: CustomButtonProps) => {
    const handleClick = () => {
        if (!isActive) return;
        onAction?.();
    };

    return (
        <div
            className={clsx(styles.customButton, { [styles.disabled]: !isActive })}
            onClick={handleClick}
        >
            {title}
        </div>
    );
};

export default CustomButton;
